<template>
    <div class="form-content" :style="customStyle">
        <template v-if="isInvitation">
            <img :src="backgroundImg" class="invitation-background-img" v-if="backgroundImg"/>
            <div class="invitation-background-img-placeholder" v-else />
        </template>
        <div :class="{invitation: isInvitation}">
            <inviter-info :account="inviterInfo" :mode="mode" v-if="isInvitation"/>
            <div class="marketing-form">
                <div class="marketing-form-header" v-if="formTitle">
                    <div class="title">{{formTitle}}</div>
                    <div class="comment" v-if="comment">{{comment}}</div>
                </div>
                <div class="marketing-form-body">
                    <div class="component-form-box">
                        <form-item v-if="forcedDisplayCarType" label="心仪车型" validateKey="formData.car_type">
                            <series-picker
                                :value="formData.car_type"
                                :placeholder="seriesPickerTitle"
                                :title="seriesPickerTitle"
                                @onChange="onConfirmSeries"
                                :options="series"
                                iconPosition="right"
                            />
                        </form-item>
                        <form-item label="姓名" validateKey="formData.name" v-if="forcedDisplayName">
                            <input type="text" v-model="formData.name" placeholder="请输入姓名" />
                        </form-item>
                        <form-item v-if="forcedDisplayArea" label="城市" validateKey="formData.driving_city_code">
                            <region-simple
                                ref="region"
                                :clientHeight="200"
                                :provinces="gisProvinces"
                                :cities="selectedCities"
                                @citiesList="onCitiesList"
                                @onConfirmRegion="onConfirmRegion"
                                iconPosition="right"
                                :useGeoLocation="useGeoLocation"
                                :handleLocatingFailed="initDefaultRegion"
                            />
                        </form-item>
                        <form-item v-if="forcedDisplayTdSite" label="门店" validateKey="formData.driving_city_code">
                           <driving-address-picker
                              ref="tdSite"
                              :showNearestTag="false"
                              :showDistance="false"
                              :lat="latitude"
                              :lng="longitude"
                              @onConfirm="onConfirmRegion"
                          />
                        </form-item>
                        <form-item label="手机号" validateKey="formData.mobile" class="mobile-box">
                            <country-code v-model="formData.country_code" @input="onCountryCode"></country-code>
                            <input
                                ref="mobileIpt"
                                class="mobile-ipt"
                                type="number"
                                pattern="[0-9]*"
                                v-model="formData.mobile"
                                placeholder="请输入手机号"
                                @focus="handleInputFocus('mobileIpt')"
                                @blur="handleInputBlur()"
                            />
                            <span class="editable-clear-x" @click="formData.mobile=''" v-show="!!formData.mobile">
                                <svg t="1599754257072" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2046" width="16" height="16">
                                    <path d="M512 0C229.187368 0 0 229.187368 0 512 0 794.812632 229.187368 1024 512 1024 794.812632 1024 1024 794.812632 1024 512 1024 229.187368 794.812632 0 512 0ZM512 970.105263C259.368421 970.105263 53.894737 764.631579 53.894737 512 53.894737 259.368421 259.368421 53.894737 512 53.894737 764.631579 53.894737 970.105263 259.368421 970.105263 512 970.105263 764.631579 764.631579 970.105263 512 970.105263ZM550.130526 512 719.629474 342.366316C730.273684 331.856842 730.273684 314.88 719.629474 304.370526 709.12 293.726316 692.143158 293.726316 681.633684 304.370526L512 473.869474 342.366316 304.370526C331.856842 293.726316 314.88 293.726316 304.370526 304.370526 293.726316 314.88 293.726316 331.856842 304.370526 342.366316L473.869474 512 304.370526 681.633684C293.726316 692.143158 293.726316 709.12 304.370526 719.629474 309.625263 724.884211 316.496842 727.578947 323.368421 727.578947 330.24 727.578947 337.111579 724.884211 342.366316 719.629474L512 550.130526 681.633684 719.629474C686.888421 724.884211 693.76 727.578947 700.631579 727.578947 707.503158 727.578947 714.374737 724.884211 719.629474 719.629474 730.273684 709.12 730.273684 692.143158 719.629474 681.633684L550.130526 512Z" p-id="2047"></path>
                                </svg>
                            </span>
                        </form-item>
                        <form-item label="验证码" validateKey="formData.verification_code" v-if="displayController.showVerification">
                            <input
                                class="verification_code_input"
                                ref="vCodeIpt"
                                type="tel"
                                @focus="handleInputFocus('vCodeIpt')"
                                @blur="handleInputBlur()"
                                pattern="[0-9]*"
                                maxLength="6"
                                v-model="formData.verification_code"
                                placeholder="请输入验证码"
                            />
                            <div class="verification" :class="{ disabled: isVerificationDis}" @click="onVerification">
                                {{ butText }}
                            </div>
                        </form-item>
                        <form-item validateKey="isAgree">
                            <privacy
                                :isAgree.sync="isAgree"
                                linkLeftTxt="我已阅读并同意"
                                :linkRightTxt="privacyName"
                                :linkTo="privacyLink"
                                :linkConfig="privacyList"
                                :showMulti="true"
                                @update:isAgree="onAgreeChange" />
                        </form-item>
                        <div class="submit-but" :style="submitButtonStyle" @click="onSubmit">{{ submitButtonText }}</div>
                    </div>
                </div>
                <alert-h5 ref="alerth5" />
                <div v-if="submitLoading" class="loading-mask" />
                <asking-modal
                    v-if="askingModal"
                    :visible="askingModalVisible"
                    @cancel="onAskingCancel"
                    @confirm="onAskingConfirm"
                    :title="askingModal.title"
                    :content="askingModal.content"
                    :cancelText="askingModal.cancelText"
                    :confirmText="askingModal.confirmText"
                />
            </div>
        </div>
    </div>
   
</template>

<script>
import validator from '@/util/validator.js';
import { urlStringify } from '@/util/string';
import { mapState, mapActions, mapMutations } from 'vuex';
import verificationMixin from '@/mixin/verification';
import formPropsMixin from '../mixin/form-props';
import formMixin from '@/mixin/form';
import resultCode from '@/config/result-code';
import config from '@/config/index.js';
import Privacy from '@/marketing_components/form/privacy/index.vue'; // @/components/form/privacy/index.vue
import CountryCode from '@/marketing_components/form/picker/country-code/index'; // @/components/form/picker/country-code/index
import SeriesPicker from '@/marketing_components/form/picker/series-picker/index'; // @/components/form/picker/series-picker/index
import RegionSimple from '@/marketing_components/form/region-simple/index'; // @/components/form/region-simple/index
import DrivingAddressPicker from '@/marketing_components/form/picker/driving-address-picker/index'; // @/components/form/picker/driving-address-picker/index
import AlertH5 from '@/marketing_components/alert-h5'; // @/components/alert-h5
import AskingModal from './asking-modal';
import InviterInfo from './inviter-info';
import { terminal as navTerminal } from '@/util/browser.js';
import { getLocation } from '@/util/platform';
import { isInNioCNApp } from '@/util/platform/universal';
import { ABOUTE_ENUMS } from '@/marketing_components/succeed/config'; // @/components/succeed/config
import { PAGE_MODE_MAP } from '@/config/enums';
import { INVITATION_CHANNEL_CODE } from '../../../config/enums';
import trackExposeMixin from '../mixin/track-expose';
import { LOGIN_INFO_EVENT_NAME } from '../config';

const mixin = {
    methods: {
        ...mapActions('marketing/', [
            'createTestDriveOrders',
            'createLeads',
            'createLeadsByLoginUser',
            'createTestDriveOrdersByLoginUser',
            'decideGuidePage',
            'rgeoDetail',
            'getIpArea',
            'checkSwitch2DefaultSuccessPage',
            'getGisAreaList'
        ]),
        ...mapMutations('marketing/', ['setSuccessStatus'])
    },
    computed: {
        ...mapState('marketing/', [
            'pageConfig',
            'campaignOption',
            'getAccountData',
            'loginInfo'
        ])
    }
};

export default {
    name: 'marketing-form',
    componentName: 'marketingForm',
    mixins: [
        mixin,
        formPropsMixin,
        formMixin(),
        verificationMixin(
            'formData.mobile',
            'formData.country_code',
            'verificationCodeClassifier'
        ),
        trackExposeMixin
    ],
    data() {
        return {
            mode: 'leads',
            seriesLabelText: {
                leads: '心仪车型',
                drive: '试驾车型'
            },
            latitude: null,
            longitude: null,
            locatedAreaCode: '', // 定位获取到的city_code
            isAgree: false,
            gisProvinces: [],
            gisProvinces$: this.loadGisProvinces(),
            selectedCities: [],
            formData: {
                campaign_code: '', // 来源
                country_code: '86', // 区号
                inviter_account_id: '', // 邀请人
                mobile: '', // 手机号
                verification_code: '', // 验证码
                name: this.presetName || '', // 原：username
                driving_city_code: '', // 原：city_id
                driving_city_name: '',
                site_id: '', // 试驾地点id
                site_name: '', // 试驾地点名称
                car_type: 'ES8',
                terminal: '', // 终端
                device_id: '', // 设备
                remark: 'h5试驾'
            },
            formRules: {
                'formData.name': {
                    require: this.fields && this.fields.indexOf('name') >= 0,
                    message: '请输入姓名'
                },
                'formData.car_type': {
                    require: true,
                    message: '请选择车型'
                },
                'formData.driving_city_code': {
                    require: true,
                    message: () => {
                        if (this.forcedDisplayTdSite) {
                            return '请选择喜欢的试驾点';
                        }
                        return '请选择城市';
                    }
                },
                'formData.mobile': {
                    validate: value =>
                        validator[
                            `validateMobile${this.formData.country_code}`
                        ](value),
                    message: '请正确填写您的手机号码'
                },
                'formData.verification_code': {
                    require: true,
                    message: '请填写验证码'
                },
                isAgree: {
                    require: true,
                    callback: () => {
                        this.$refs.alerth5.onOpen();
                    }
                }
            },
            submitLoading: false,
            askingModalVisible: false
        };
    },
    created() {
        this.nioAppPageInit();
        this.handleLoginInfo();
    },
    async mounted() {
        await this.gisProvinces$;
        this.mode = this.formMode;
        this.handleCityCode();
    },
    watch: {
        // uniqueKey移到mounted解析后会有时序问题，导致没有把uniqueKey里解析的车型带到表单，所以这里从mounted移到watch
        presetModel: {
            handler(v) {
                if (!v) return;
                this.formData.car_type = v.toLowerCase();
            },
            immediate: true
        },
        privacyAgreed: {
            handler(v) {
                this.isAgree = v;
            },
            immediate: true
        }
    },
    methods: {
        async loadGisProvinces() {
            return this.getGisAreaList().then(({ data }) => {
                console.log('getGisAreaList', data)
                this.gisProvinces = (data.provinces || []).map(x => ({
                    id: +x.areaCode,
                    name: x.name,
                    cities: (x.cities || []).map(y => ({
                        city_id: +y.areaCode,
                        city_name: y.name
                    }))
                }));

                return this.gisProvinces;
            });
        },
        // app内 初始化
        nioAppPageInit() {
            if (!isInNioCNApp()) return;
            this.$root.$on(LOGIN_INFO_EVENT_NAME, res => {
                this.formData.country_code = res.country_code || '86';
                this.formData.mobile = res.mobile || '';
                this.formData.verification_code = '';
            });
        },
        handleLoginInfo() {
            // 悬浮组件的表单created比页面慢 拿不到初始化时获取的登录信息
            if (!this.loginInfo.mobile || !this.loginInfo.access_token) {
                return;
            }
            this.formData.country_code = this.loginInfo.country_code || '86';
            this.formData.mobile = this.loginInfo.mobile || '';
            this.formData.verification_code = '';
        },
        async handleCityCode() {
            // 表单项不需要显示 赋值即可
            if (!this.forcedDisplayArea && !this.forcedDisplayTdSite) {
                this.formData.driving_city_code = this.presetAreaCode;
                return;
            }

            if (this.forcedDisplayArea) {
                // 展示城市选择需要获取省份列表
                if (!this.gisProvinces || !this.gisProvinces.length) {
                    await this.gisProvinces$;
                }
                if (!this.useGeoLocation) {
                    // 开启定位时交给region-picker自行解决
                    // 关闭时直接初始化，需要city_code=>city_name
                    this.initDefaultRegion();
                }
            }
            if (this.forcedDisplayTdSite) {
                if (this.useGeoLocation) {
                    this.initTdSite();
                } else {
                    this.setDefaultTdSite();
                }
            }
        },
        // 覆盖mixin中的方法
        trackExposeAction() {
            this.$emit('trackExposeAction', {
                niohouse_id: this.formData.site_id,
                niohouse_name: this.formData.site_name
            });
        },
        trackRetentionFlow(custom = {}) {
            if (!this.isDemo) {
                this.$tracker.collectPlus('RetentionFlow', {
                    lp_id: this.lpConfig.lpId,
                    campaign_code: this.pageConfig.campaignSourceCode,
                    invite_account: this.campaignOption.accountId,
                    car_model:
                        this.realCarType && this.realCarType.toUpperCase(),
                    city: this.formData.driving_city_name,
                    niohouse_id: this.formData.site_id,
                    niohouse_name: this.formData.site_name,
                    page: PAGE_MODE_MAP[this.mode],
                    ...custom,
                    // 新属性
                    requirement_id: 1435,
                    track_sign: 'aCar.b1013.c1799.d1809.result.RetentionFlow',
                    link: window.location.href,
                    component_id: this.componentId,
                    mkt_type: this.trackName,
                    position_rank: this.positionRank,
                    is_clickable: true,
                    fellow_emp_domain: this.campaignOption.fellowEmpDomain,
                    fellow_name: this.campaignOption.registerEmpDomain
                });
            }
        },
        async initTdSite() {
            // #1 初始化定位
            await this.initLocation();

            // #2 回显门店
            this.setDefaultTdSite(this.locatedAreaCode);
        },
        async initLocation() {
            try {
                // #1.1 精确定位
                const { lat, lng } = await getLocation();

                // #1.2 逆解析
                const res = await this.rgeoDetail({
                    latitude: lat,
                    longitude: lng
                });
                if (!res.city_code) {
                    throw {
                        message: res.message || '逆地址解析失败',
                        result_code: res.result_code || 'rgeo_failed'
                    };
                }

                this.latitude = lat;
                this.longitude = lng;
                this.locatedAreaCode = res.city_code;
            } catch (e) {
                console.warn('[Form] accurate positioning failed: ', e);
                this.latitude = null;
                this.longitude = null;
                this.locatedAreaCode = '';

                // #2.1 ip定位获取城市信息
                await this.getIpLocationArea();
            }
        },
        async getIpLocationArea() {
            try {
                const res = await this.getIpArea();

                if (res.resultCode !== 'success') {
                    throw res;
                }
                this.locatedAreaCode = res.data.cityCode || ''; // 海外ip应该拿不到
            } catch (e) {
                this.locatedAreaCode = '';
                console.warn('[Form] ip positioning failed:', e);
            }
        },
        setDefaultTdSite(areaCode = '') {
            const cityId = areaCode || this.presetAreaCode;

            if (!cityId) {
                return;
            }
            return this.$refs.tdSite.selectDefaultSite(cityId);
        },
        async initDefaultRegion(code) {
            if (!code && !this.presetAreaCode) return;
            const cityId = code || this.presetAreaCode;
            const province_id = cityId.replace(/[0-9]{4}$/, '0000');
            await this.gisProvinces$;

            const selectedProvince = this.gisProvinces.find(
                x => String(x.id) === String(province_id)
            );

            if (selectedProvince && selectedProvince.cities) {
                this.selectedCities = selectedProvince.cities;

                const city = this.selectedCities.find(
                    item => String(item.city_id) === String(cityId)
                );
                this.$refs.region &&
                    this.$refs.region.selectedCity(city, false);
            } else {
                this.selectedCities = [];
            }
        },
        // 查询城市列表
        onCitiesList(province_id) {
            const selectedProvince = this.gisProvinces.find(
                x => String(x.id) === String(province_id)
            );

            if (selectedProvince && selectedProvince.cities) {
                this.selectedCities = selectedProvince.cities;
            } else {
                this.selectedCities = [];
            }

            return this.selectedCities;
        },
        // 确认城市/试驾门店
        onConfirmRegion(param) {
            this.formData.driving_city_code = param.city_id + '';
            this.formData.driving_city_name = param.city_name + '';
            this.formData.site_id = param.site_id ? `${param.site_id}` : '';
            this.formData.site_name = param.site_name || '';

            if (param.city_name) {
                this.trackRetentionFlow({ step_name: 'city' });
            }
        },
        // 确认车型
        onConfirmSeries(param) {
            this.formData.car_type = param;
            this.trackRetentionFlow({ step_name: 'car_model' });
        },
        onCountryCode() {
            this.formData.mobile = '';
            this.trackRetentionFlow({ step_name: 'code' });
        },
        onAgreeChange(checked) {
            this.$emit('update:privacyAgreed', checked);
            if (checked) {
                this.trackRetentionFlow({ step_name: 'agree_privacy' });
            }
        },
        onAskingCancel(flag) {
            if (!flag) {
                this.askingModalVisible = false;
            } else {
                this.mode = 'leads';
                this.submitForm();
            }
        },
        onAskingConfirm() {
            this.mode = 'drive';
            this.submitForm();
        },
        onSubmit() {
            if (!this.submitLoading && this.checkForm()) {
                if (this.askingModal && this.askingModal.enabled) {
                    this.askingModalVisible = true;
                } else {
                    this.submitForm();
                }
            }
        },
        _getBasicForm() {
            const {
                name,
                driving_city_code,
                country_code,
                mobile,
                verification_code,
                site_id
            } = this.formData;
            return {
                campaign_code: this.pageConfig.campaignSourceCode,
                device_id:
                    navTerminal && navTerminal() ? navTerminal().userAgent : '',
                terminal: JSON.stringify({
                    app_id: config.app_id,
                    desc: 'apollo-h5'
                }),
                register_account: true,
                inviter_account_id: this.campaignOption.accountId,
                channel: 'apollo_h5',
                inviter_channel:
                    this.campaignOption.inviterChannel ||
                    this.presetChannel ||
                    INVITATION_CHANNEL_CODE.page,
                name: name || '蔚来用户',
                car_types: this.realCarType,
                driving_city_code,
                site_id,
                country_code,
                mobile,
                verification_code,
                fellow_emp_domain: this.campaignOption.fellowEmpDomain,
                register_emp_domain: this.campaignOption.registerEmpDomain,
                nio_third_party_code: this.campaignOption.nioThirdPartyCode,
                nio_third_party_query_key: this.campaignOption
                    .nioThirdPartyQueryKey // 三方对接
            };
        },
        _getMobileVerifyCreateForm() {
            return this._getBasicForm();
        },
        _getLoginUserCreateForm() {
            return {
                ...this._getBasicForm(),
                headers: { authorization: this.loginInfo.access_token }
            };
        },
        /**
         * 提交
         */
        submitForm() {
            if (this.isDemo) {
                this.handleJumpAfterSubmit();
                return;
            }
            this.submitLoading = true;
            // 点击埋点
            this.trackRetentionFlow({
                step_name: 'begin',
                tj_component: this.trackName
            });
            this.trackRetentionFlow({
                step_name: 'select_component'
            });

            // 登录用户带token
            let form = {};
            if (this.isLoginUser) {
                form = this._getLoginUserCreateForm();
            } else {
                form = this._getMobileVerifyCreateForm();
            }

            let submitPromise;
            if (this.mode === 'leads') {
                submitPromise = this.isLoginUser
                    ? this.createLeadsByLoginUser(form)
                    : this.createLeads(form);
            } else {
                submitPromise = this.isLoginUser
                    ? this.createTestDriveOrdersByLoginUser(form)
                    : this.createTestDriveOrders(form);
            }
            submitPromise
                .then(res => {
                    if (res.result_code !== 'success') {
                        this.submitLoading = false;
                        const msg = resultCode[res.result_code];
                        this.trackSubmitResult({
                            is_success: false,
                            failure_reason: res.result_code,
                            failure_message: msg || res.message || res.debug_msg
                        });
                        this.$message(msg || res.message || '网络延迟，请再提交一次');
                        return Promise.reject();
                    }

                    const {
                        new_user,
                        user,
                        order_person_account_id,
                        order_no
                    } = res.data;
                    const orderAccountId = user
                        ? user.account_id
                        : order_person_account_id;
                    this.trackSubmitResult({
                        is_success: true,
                        account_id: orderAccountId,
                        nio_user_id: user ? user.user_id : '',
                        order_no
                    });
                    return res.data;
                })
                .then(data => {
                    return this.handleJumpAfterSubmit(data);
                })
                .finally(() => {
                    this.submitLoading = false;
                });
        },
        async handleJumpAfterSubmit(data = {}) {
            // #1 优先组件跳转配置逻辑
            if (this.guideLink) {
                location.replace(this.guideLink);
                return;
            }

            // #2 兜底引导页决策逻辑
            return this.redirectToGuide(data);
        },
        async redirectToGuide(
            { new_user = true, user = {}, invitee_invite_info } = {}
        ) {
            const { car_type, driving_city_code } = this.formData;
            const landingPageId = this.lpConfig.lpId;
            const landingPageToken = this.lpConfig.lpToken;
            // 引导页决策参数
            const guideOptions = {
                guidePlanId: this.guidePlan && this.guidePlan.groupId,
                mobile: user.mobile,
                cityId: driving_city_code,
                landingPageId,
                landingPageToken,
                carType: this.realCarType.toUpperCase(),
                intentionType: this.mode === 'leads' ? 1 : 2,
                userId: user.user_id,
                newUser: new_user,
                platform: 2
            };
            // 默认引导页面配置
            const prefix = this.mode === 'leads' ? 'LEADS' : 'FRIEND';
            let status = '';
            if (!invitee_invite_info) {
                // 默认无邀请关系
                status =
                    this.mode === 'leads'
                        ? ABOUTE_ENUMS.LEADS
                        : ABOUTE_ENUMS.DRIVER;
            } else if (invitee_invite_info.isSelf) {
                status = ABOUTE_ENUMS[`${prefix}SELF`];
            } else if (invitee_invite_info.isEmployee) {
                status = ABOUTE_ENUMS[`${prefix}EMPLOYEE`];
            } else if (invitee_invite_info.isOwner) {
                status = ABOUTE_ENUMS[`${prefix}OWNER`].FRIEND;
            } else if (invitee_invite_info.isSameInviter) {
                status = ABOUTE_ENUMS[`${prefix}SAMEINVITER`];
            } else if (invitee_invite_info.isInvite) {
                status = ABOUTE_ENUMS[`${prefix}INVITE`];
            } else {
                status =
                    this.mode === 'leads'
                        ? ABOUTE_ENUMS.LEADSFRIEND
                        : ABOUTE_ENUMS.FRIEND;
            }
            try {
                // 判断是否分流
                const res = await this.checkSwitch2DefaultSuccessPage({
                    campaignCode: this.pageConfig.campaignSourceCode,
                    scene: 'landing_page',
                    userCode: user.user_code,
                    bizId: landingPageId
                });
                if (res.data) {
                    const params = {
                        scene: 'landing_page',
                        campaignCode: this.pageConfig.campaignSourceCode,
                        ...(this.campaignOption.fellowEmpDomain
                            ? {
                                  fellowEmpDomain: this.campaignOption
                                      .fellowEmpDomain
                              }
                            : {})
                    };
                    location.replace(
                        `/hana-pro/pages/default-success-page?${urlStringify(
                            params
                        )}`
                    );
                    return new Promise(resolve => {
                        setTimeout(() => resolve(), 200);
                    });
                }
            } catch (error) {
                // catch不做处理
                console.log(
                    '[checkSwitch2DefaultSuccessPage error] ===>',
                    error
                );
            }
            return this.decideGuidePage(guideOptions)
                .then(res => {
                    const guideData = res.data;
                    if (guideData && guideData.gp_id) {
                        const params = {
                            source_lpid: landingPageId,
                            car_type,
                            user_id: user.user_id,
                            new_user: new_user ? '1' : '0'
                        };
                        // 跳转引导页 - 告知引导页所选车型
                        location.replace(
                            `/guide/${guideData.gp_id}?${urlStringify(params)}`
                        );
                    } else {
                        // 展示默认页
                        this.setSuccessStatus(status);
                    }
                })
                .then(() => {
                    // 延迟一下，防止跳转前重新点击提交
                    return new Promise(resolve => {
                        setTimeout(() => resolve(), 200);
                    });
                })
                .catch(e => {
                    // 展示默认页
                    this.setSuccessStatus(status);
                });
        },
        trackSubmitResult(custom = {}) {
            if (this.mode === 'leads') {
                this.trackRetentionFlow({
                    step_name: 'getmessage_success',
                    ...custom
                });
            } else {
                this.trackRetentionFlow({
                    step_name: 'testdrivebook_success',
                    tdorder_status: '待安排',
                    ...custom
                });
            }
        },
        // 新老页面过度期的不同上报事件的兼容处理
        trackerBindPhone(custom = {}) {
            this.trackRetentionFlow({
                step_name: 'bind_phone',
                ...custom
            });
        },
        handleInputFocus(key) {
            const targetEl = this.$refs[key];
            this.$emit('inputFocus', this.rootMark, targetEl);
        },
        handleInputBlur() {
            this.$emit('inputBlur', this.rootMark);
        }
    },
    computed: {
        isInApp() {
            return isInNioCNApp();
        },
        verificationCodeClassifier() {
            return this.isInApp ? 'login' : 'common_verification';
        },
        seriesPickerTitle() {
            return `请选择${this.seriesLabelText[this.mode]}`;
        },
        forcedDisplayArea() {
            // 不展示试驾地点时，如果没有默认城市则必须展示城市选择
            return (
                (this.fields && this.fields.indexOf('area') >= 0) ||
                (!this.forcedDisplayTdSite && !this.presetAreaCode)
            );
        },
        forcedDisplayTdSite() {
            return this.fields && this.fields.indexOf('tdSite') >= 0;
        },
        forcedDisplayName() {
            return this.fields && this.fields.indexOf('name') >= 0;
        },
        forcedDisplayCarType() {
            return this.fields && this.fields.indexOf('carType') >= 0;
        },
        isSubmitDis() {
            if (
                this.isAgree &&
                this.formData.driving_city_code &&
                this.formData.mobile &&
                this.formData.verification_code
            ) {
                return false;
            }
            return true;
        },
        realCarType() {
            const carType = this.formData.car_type;
            const carInfo = this.series.find(s => s.value === carType);
            return (carInfo && carInfo.code) || carType;
        },
        inviterInfo() {
            return this.getAccountData;
        },
        isInvitation() {
            return this.bizType === 'INVITATION';
        },
        isLoginUser() {
            return !!this.loginInfo.mobile;
        },
        isLoginUserSelf() {
            return this.loginInfo.mobile === this.formData.mobile;
        },
        displayController() {
            return { showVerification: !this.isLoginUserSelf };
        }
    },
    components: {
        Privacy,
        CountryCode,
        SeriesPicker,
        RegionSimple,
        DrivingAddressPicker,
        AlertH5,
        AskingModal,
        InviterInfo
    }
};
</script>

<style lang="less" scoped>
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';

.form-content{
    .invitation {
        box-shadow: 0px 5 * @layout375 10 * @layout375 0px rgba(0, 0, 0, 0.05);
        border-radius: 5 * @layout375;
        margin: -60 * @layout375 25 * @layout375 25 * @layout375 25 * @layout375;
        position: relative;
        background-color: white;
    } 
    .invitation-background-img{
        width: 100%;
    } 
    .invitation-background-img-placeholder{
        height: 90 * @layout375;
    }
    .marketing-form {
        display: flex;
        flex-direction: column;
        padding: 0 25 * @layout375;
        .marketing-form-header {
            position: relative;
            padding: 20 * @layout375 0;
            color: #363C54;
            .title {
                font-size: 20 * @layout375;
                font-weight: bold;
                line-height: 20 * @layout375;
            }
            .comment {
                padding-top: 10 * @layout375;
                color: #363C54;
                font-size: 14 * @layout375;
            }
        }
        .marketing-form-body {
            .verification_code_input {
                flex: 1;
                width: 6em;
            }
            .verification {
                width: 80 * @layout375;
                min-width: 80 * @layout375;
                height: 25 * @layout375;
                line-height: 25 * @layout375;
                border-radius: 18 * @layout375;
                text-align: center;
                font-size: 12 * @layout375;
                color: #363c54;
                margin-left: 10 * @layout375;
                background: #f0fcfc;
                color: #00bebe;
                &.disabled {
                    background: #f7f7f8;
                    color: #9b9da9;
                }
            }
            .verification-img {
                width: 100px;
                height: 40px;
            }
            .mobile-box {
                input {
                    width: 100%;
                    font-size: 16 * @layout375;
                }
                .editable-clear-x {
                    display: inline-flex;
                    line-height: 44 * @layout375;
                    position: absolute;
                    right: 2 * @layout375;
                    width: 20 * @layout375;
                }
            }
            .submit-but {
                height: 45 * @layout375;
                margin-top: 16 * @layout375;
                margin-bottom: 15 * @layout375;
                font-size: 16 * @layout375;
                color: #ffffff;
                background: #00bcbc;
                border-radius: 25 * @layout375;
                .center();
                position: relative;
                &.disabled {
                    background: #cdced4;
                    color: #fff;
                }
            }
        }
        .loading-mask {
            position: fixed;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 9999;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/marketing/components/form.vue